import React, { useState } from "react";
import atticusLightLogo from "../../assets/logos/full_logo_light.png";
import atticusLighterLogo from "../../assets/logos/full_logo_lighter.png";

const navigation = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/tourney_tents_md/",
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path
          fillRule="evenodd"
          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
];

export default function Footer() {
  const [atticusHovered, setAtticusHovered] = useState(false);

  return (
    <footer className="bg-ttNavy-500">
      <div className="mx-auto max-w-7xl px-6 py-4 flex flex-col items-center space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0 lg:px-8">
        {/* Left: Social Links */}
        <div className="flex justify-center space-x-6">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              className="text-ttBlue-500 hover:text-ttBlue-400"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>

        {/* Center: Copyright */}
        <div>
          <p className="text-center text-xs leading-5 text-ttBlue-500">
            &copy; {new Date().getFullYear()} Tourney Tents LLC. All rights
            reserved.
          </p>
        </div>

        {/* Right: Powered by Atticus */}
        <div className="flex justify-center items-end text-xs leading-5 text-gray-500">
          <span className="mr-2">Powered by</span>
          <a
            href="https://www.atticuslabs.net"
            target="_blank"
            rel="noreferrer"
            className="flex items-center"
          >
            <img
              src={atticusHovered ? atticusLighterLogo : atticusLightLogo}
              onMouseEnter={() => setAtticusHovered(true)}
              onMouseLeave={() => setAtticusHovered(false)}
              alt="Atticus Logo"
              className="h-8"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
